import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { setFileActionRequest } from '../../api/Workflow/setFileActionCommand';

import * as ActionTypes from './actionTypes';

export function* setFileActionWorker({ payload = {} }) {
  const { fileId, fromState, toState, comment, toCustomerComment, module } =
    payload;

  yield executeSagaRequest(
    ActionTypes.SET_FILE_ACTION,
    setFileActionRequest({
      fileId,
      fromState,
      toState,
      module,
      comment,
      toCustomerComment,
    }),
  );
  yield put(ActionTypes.SET_FILE_ACTION.end());
}
function* setFileActionWatcher() {
  yield takeEvery(ActionTypes.SET_FILE_ACTION.BASE, setFileActionWorker);
}

export default function* workflowSaga() {
  try {
    yield all([setFileActionWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
